<template>
  <a-modal
    title="选择生成的合同号"
    :width="780"
    :visible="visible"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="名称" :label-col="formLayout.labelCol" :wrapper-col="formLayout.wrapperCol">
              <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="内容" :label-col="formLayout.labelCol" :wrapper-col="formLayout.wrapperCol">
              <a-input v-decorator="['content', {rules: [{required: true, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    }
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    ok () {
      this.$emit('ok')
    }
  }
}
</script>
